import dailyReport from './dailyReport';
import monthlyReport from './monthlyReport';

export default {
  dailyReport,
  monthlyReport,
};
